export default __webpack_public_path__ + "static/media/Dashboard_card1.c16831fd.png";